import { render } from "./calculator_de.vue?vue&type=template&id=34d302da"
import script from "./calculator_de.vue?vue&type=script&lang=js"
export * from "./calculator_de.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/project/wp-content/themes/resource-database/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__